import React, { useState } from 'react';
import API from '../api';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

const Signup = () => {
  const [shopName, setShopName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submittedEmail, setSubmittedEmail] = useState('');
  const isProduction = window.location.hostname !== 'localhost';

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      await API.post('/auth/signup', { shop_name: shopName, email, password });
      setSubmittedEmail(email);
      setSubmitted(true);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Signup failed');
    }
  };

  const handleGoogleLogin = () => {
    window.location.href = isProduction 
      ? 'https://billsaas-uncle-backend.onrender.com/api/auth/google'
      : 'http://localhost:5000/api/auth/google';
  };
  if (submitted) {
    return (
      <div style={styles.container} className="container">
        <div style={styles.card}>
          <div style={{ fontSize: '48px', marginBottom: '1rem' }}>📧</div>
          <h2 style={styles.title}>Check your email!</h2>
          <p style={styles.subtitle}>We sent a verification link to <strong>{submittedEmail}</strong></p>
          <p style={{ color: '#888', fontSize: '13px', marginBottom: '1.5rem' }}>Click the link in the email to activate your account.</p>
          <Link to="/" style={styles.backLink}>← Back to Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container} className="container">
      <div style={styles.card}>
        <div style={{ textAlign: 'center', marginBottom: '0rem' }}>
  <img src="/logo.png" alt="Wahi POS" style={{ height: '120px', objectFit: 'contain' }} />
</div>
<button onClick={handleGoogleLogin} style={styles.googleBtn}>          <img src="https://www.google.com/favicon.ico" alt="Google" style={{ width: '18px', height: '18px' }} />
          Sign up with Google
        </button>
        <div style={styles.divider}>
          <span style={styles.dividerLine}></span>
          <span style={styles.dividerText}>or</span>
          <span style={styles.dividerLine}></span>
        </div>
        <form onSubmit={handleSignup}>
          <input style={styles.input} type="text" placeholder="Shop Name" value={shopName} onChange={(e) => setShopName(e.target.value)} required />
          <input style={styles.input} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input style={styles.input} type="password" placeholder="Password (min 6 characters)" value={password} onChange={(e) => setPassword(e.target.value)} minLength={6} required />
          <button style={styles.button} type="submit">Create Account</button>
        </form>
        <p style={styles.link}>Already have an account? <Link to="/">Login</Link></p>
      </div>
    </div>
  );
};

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f0f2f5' },
  card: { background: '#fff', padding: '2rem', borderRadius: '12px', width: '100%', maxWidth: '400px', boxShadow: '0 2px 12px rgba(0,0,0,0.1)' },
  logoSection: { textAlign: 'center', marginBottom: '1.5rem' },
  logo: { fontSize: '28px', margin: '0 0 0.25rem', color: '#4f46e5' },
  tagline: { color: '#888', fontSize: '13px', margin: 0 },
  googleBtn: { width: '100%', padding: '10px', background: '#fff', color: '#333', border: '1px solid #ddd', borderRadius: '8px', fontSize: '15px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '1rem', fontWeight: '500' },
  divider: { display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' },
  dividerLine: { flex: 1, height: '1px', background: '#ddd' },
  dividerText: { color: '#888', fontSize: '13px' },
  input: { width: '100%', padding: '10px', marginBottom: '1rem', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' },
  button: { width: '100%', padding: '10px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer' },
  link: { textAlign: 'center', marginTop: '1rem', fontSize: '14px' },
  subtitle: { color: '#555', marginBottom: '0.5rem', fontSize: '14px' },
  title: { fontSize: '22px', marginBottom: '0.5rem' },
  backLink: { color: '#4f46e5', textDecoration: 'none', fontSize: '14px' },
};

export default Signup;